import { render } from "./ProjectItem.vue?vue&type=template&id=977cdf4c&scoped=true"
import script from "./ProjectItem.vue?vue&type=script&lang=js"
export * from "./ProjectItem.vue?vue&type=script&lang=js"

import "./ProjectItem.vue?vue&type=style&index=0&id=977cdf4c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-977cdf4c"

export default script